import { registerComponent } from '@gig/magic-common';
import CheckboxComponent from './checkbox.vue.js';

var Checkbox = registerComponent(CheckboxComponent);

export { Checkbox };
